import { type FC, type MouseEventHandler } from 'react';
import { BsArrowLeft } from 'react-icons/bs';

import styles from './BackButton.module.css';

type BackButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

const BackButton: FC<BackButtonProps> = ({ onClick }) => (
  <button data-testid="facelift-back-button" type="button" onClick={onClick} className={styles.buttonPrevious}>
    <BsArrowLeft />
  </button>
);

BackButton.displayName = 'BackButton';

export default BackButton;
